import type { OneText } from '../../global';

declare let onetext : OneText;

const loader = async () : Promise<void> => {
    const { register } = onetext.popup;
    const {
        StandardPopup,
        XmasPopup,
        NewYearPopup,
        EvergreenHeartPopup20Off,
        EvergreenHeartPopup15Off,
        FamilySalePopup,
        ValentinesDay
    } = await import('./popups');

    register({ externalID: 'standard', Component: StandardPopup });
    // Temporarily removed some old template registrations to reduce file size
    register({ externalID: 'xmas', Component: XmasPopup });
    register({ externalID: 'new_year', Component: NewYearPopup });
    register({ externalID: 'evergreen_heart_20_off', Component: EvergreenHeartPopup20Off });
    register({ externalID: 'evergreen_heart_15_off', Component: EvergreenHeartPopup15Off });
    register({ externalID: 'family_sale', Component: FamilySalePopup });
    register({ externalID: 'valentines_day', Component: ValentinesDay });
};

window.onLoadOneText ??= [];

window.onLoadOneText.push({
    name:       sdk.brand?.name,
    commitHash: sdk.commitHash,
    loader
});
